// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"support_mobile_wrapper__OiAxF","card":"support_mobile_card__uMwtl","content":"support_mobile_content__P7dZk","mail":"support_mobile_mail__NF_Sk"};